import {
  EnvironmentBadge,
  PaymentsSettings,
  useOrganisationClientType,
} from "@/components/PaymentsSettings";
import { useAuth } from "@/auth/AuthContext";
import { PageContainer, PageHeader } from "@/components/PagePrimitives";

export function PaymentSettingsPage() {
  const { activeOrganisationId } = useAuth();
  const { clientType } = useOrganisationClientType(activeOrganisationId ?? null);

  return (
    <PageContainer size="narrow">
      <PageHeader
        eyebrow="Receivables"
        title="Payment settings"
        actions={clientType ? <EnvironmentBadge clientType={clientType} /> : undefined}
      />
      <PaymentsSettings />
    </PageContainer>
  );
}
